export default [
  // ebg签约发起
  {
    path: "ebg-sales-apply-2026",
    name: "ebgSalesApply2026",
    meta: {
      activename: "ebgSalesApply2026"
    },
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/EBG/apply/rad.vue")
  },
  // ebg 签约成功
  {
    path: "ebg-sales-apply-success-2026",
    name: "ebgSalesApplySuccess2026",
    component: () =>
      import(
        "@/views/channelAgreement/twentyTwentySix/EBG/apply/applySuccess.vue"
      )
  },
  // ebg续签
  {
    path: "ebg-sales-renewal-2026",
    name: "ebgSalesRenew2026",
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/EBG/renew/renew.vue")
  },
  // ebg审批页面
  {
    path: "ebg-sales-approve-2026",
    name: "ebgSalesApprover2026",
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/EBG/approve/index.vue")
  },
  // 详情页
  {
    path: "ebg-sales-detail-2026",
    name: "ebgSalesDetail2026",
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/EBG/detail/index.vue")
  },
  // 编辑页
  {
    path: "ebg-sales-edit-2026",
    name: "ebgSalesEdit2026",
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/EBG/edit/index.vue")
  },
  // 渠道确认
  {
    path: "ebg-sales-channel-confirm-2026",
    name: "ebgSalesChannelConfirm2026",
    component: () =>
      import(
        "@/views/channelAgreement/twentyTwentySix/EBG/channelConfirm/index"
      )
  },
  // 渠道确认成功
  {
    path: "ebg-sales-channel-confirm_success-2026",
    name: "ebgSalesChannelConfirmSuccess2026",
    component: () =>
      import(
        "@/views/channelAgreement/twentyTwentySix/EBG/channelConfirm/channelConfirmSuccess"
      )
  },
  // 重新提交
  {
    path: "ebg-sales-resubmit-2026",
    name: "ebgSalesResubmit2026",
    component: () =>
      import("@/views/channelAgreement/twentyTwentySix/EBG/resubmit/index")
  }
];



// WEBPACK FOOTER //
// ./src/router/ebg2026.js